import React, { useState } from "react";
import PropTypes from "prop-types";
import FileInputComponent from "react-file-input-previews-base64";
import "./imageUpload.scss";

const ImageUpload = ({ uploadImage = () => null }) => {
  const [file, setFile] = useState('')

  const getFiles = (file) => {
    setFile(file);
  }

  const saveAndUpload = () => {
    uploadImage(file);
  }

  return (
    <div className="image-select">
      {!file && (
        <div className="image-select__title">
          Click Select Image button below to upload an image from your computer.
        </div>
      )}

      <FileInputComponent
        multiple={false}
        callbackFunction={(fileArr) => {
          getFiles(fileArr.base64);
        }}
        buttonComponent={
          <button className={`trigger-btn ${file && "trigger-btn--selected"}`}>
            Select Image
          </button>
        }
        accept="image/*"
        imageStyle={{
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          objectFit: "cover",
          position: "relative",
          marginBottom: "25px"
        }}
        labelStyle={{
          display: "none"
        }}
        imageContainerStyle={{}}
      />
      {file && (
        <button className="image-select__save-btn" onClick={saveAndUpload}>
          Save
        </button>
      )}
    </div>
  );

}

export default ImageUpload

ImageUpload.prototypes = {
  uploadImage: PropTypes.func
};

